<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="callInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-15 pr-3 pl-3" v-else>
            <div class="breadcrumbnew">
                <span @click="goBack()">Leads</span>
                <a> Create Lead </a>
            </div>
            <!-- <div class="d-flex">
                <div class="blue_header pointer" :class="{'activeColor':lead == false}" @click="selectTab('lead')">
                    <span>Create Lead</span>
                </div>
                <div class="blue_header_triangle" :class="{'activeTab':lead == false}"></div>
                <div class="blue_header pointer" :class="{'activeColor':classification == false}" @click="selectTab('classification')">
                    <span>Classification</span>
                </div>
                <div class="blue_header_triangle" :class="{'activeTab':classification == false}"></div>
            </div> -->
            <div class="main-div">
                <div class="row">
                    <div class="col-lg-12 px-0">
                        <div class="pb-6 px-0 mb-0">
                          <div class="text-center fs-14 fw-600" style="color: #003cb9">
                            CREATE LEAD INFORMATION
                          </div>
                          <div class="d-flex justify-content-center align-items-center w-100 mt-6">
                                <span :class="lead ? 'selectedCircle' : classification ? 'finishedCircle' : 'unfinishedCircle'" class="mx-5">
                                    1
                                    <span :class="lead || classification ? 'finishedCircleText' : 'unfinishedCircleText'">
                                     Create Lead
                                    </span>
                                </span>
                                <span>
                                ---------------
                                </span>
                                <span :class="classification ? 'selectedCircle' : classification ? 'finishedCircle' : 'unfinishedCircle'" class="mx-5">
                                    2
                                    <span :class="classification ? 'finishedCircleText' : 'unfinishedCircleText'">
                                    Classification
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-div mt-4" v-if="lead">
                <div class="header-outer mb-3">
                    <span class="fw-500">Lead Information</span>
                    <span class="pointer" @click="showHideLeadInformation">
                        <i v-if="leadInformationTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="leadInformationTab">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Title
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" @search-change="searchTitle" :searchable="true" v-model="newLead.title" :options="organisationSettings.hasOwnProperty('leads_settings') ? organisationSettings.leads_settings.title : []" placeholder="--Select--">
                                            <template slot="afterList">
                                                <div class="add-vendor fw-500" v-if="add_title" @click="addTitle()">
                                                    Add New Title <span class="text-secondary fw-500">'{{add_title}}'</span>
                                                    <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                </div>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Title Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="pointer" @click="changeView()">
                                        <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                            <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-5" style="width:20px" alt="">
                                        </el-tooltip>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Lead Contact Name
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">Select a Lead Contact if already exists <br> in the dropdown.</span>
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100" style="padding-right: 32px">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4" name="leadcontactname" :searchable="true" v-model="newLead.lead_user_reference" :options="leadContacts" :loading="isLoading.leadcontactname" @open="getLeadContacts" @search-change="getLeadContacts" @close="dropdownClosed" @select="leadContactNameSelected" :custom-label="leadContactNameLabel" placeholder="Search or Select Contact Name">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreLeadContacts" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Contact Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadcontactname')">Lead Contact Name is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Lead Contact Number
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">Contact Number is Auto-filled if <br> Lead Contact exists, else add the Contact <br> Number here.</span>
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <div class="">
                                    <div class="w-100 mt-4 d-flex align-items-center">
                                        <vue-tel-input class="teleContactborderedDark new-align-tel ml-0" name="leadcontactnumber" placeholder="Enter Lead Contact Number" v-model="newLead.lead_user_phone.phone_number" :disabledFormatting="false" :enabledCountryCode="false" :valid-characters-only="true" :maxLen="15" v-validate="{required:true,min:10}" style="width:100% !important;"></vue-tel-input>
                                        <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadcontactnumber')">{{ errors.first('leadcontactnumber') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div class="d-flex align-items-center">
                                <div class="form-group w-100">
                                    <input class="inputFieldNew mt-6" style="padding: 8px 11px 10px 8px !important" type="email" v-model="newLead.lead_user_email" name="contectemail" v-validate="'email'" placeholder="Enter Lead Contact Email" />
                                    <span class="inputBorder"></span>
                                    <label class="inputLabel fs-14 fw-600" style="top: 0px !important;">
                                        Lead Contact Email
                                        <sup class="fs-14 ml-02 mandatory">
                                            <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                                <div slot="content" style="color: #fff; font-size: 12px;">
                                                    <span style="font-weight: 600;">Lead Contact Email is Auto-filled if <br> Lead Contact exists, else add the Lead <br> Contact Email here.</span>
                                                </div>
                                                <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                            </el-tooltip>
                                        </sup>
                                    </label>
                                </div>
                                <i class="icon icon-check-circle fs-30 mt-9 ml-2" style="color: #ff9a06;"></i>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('contectemail')">Please enter valid email address</span>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Lead Source (Channel)
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" :searchable="true" v-model="newLead.lead_source" :options="leadSources" placeholder="Search or  Select Lead Source (Channel)">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Leadsource Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Campaign Source
                                    <sup class="fs-14 ml-1 mandatory">
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">Select a Campaign Source if already exists <br> in the dropdown, else add a Lead <br> Contact here.</span>
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :searchable="true" v-model="newLead.campaign_source" @search-change="searchCampaign" :options="organisationSettings.hasOwnProperty('leads_settings') ? organisationSettings.leads_settings.campaign_source : []" :loading="isLoading.leadcampaignsource" placeholder="Search or Select Campaign Source">
                                            <template slot="afterList">
                                                <div class="add-vendor fw-500">
                                                    Add New Campaign <span class="text-secondary fw-500">'{{add_campaign}}'</span>
                                                    <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                </div>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Campaign Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="pointer" @click="changeView()">
                                        <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                            <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-5 mr-1" style="width:20px" alt="">
                                        </el-tooltip>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Lead Type
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100" style="padding-right: 32px">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="leadstatus" :searchable="true" v-model="newLead.lead_status" :options="leadStatuses" placeholder="Search or Select Lead Type">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Lead Type Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                          <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Lead Company Name
                                </span>
                                <div class="d-flex align-items-center" style="padding-right:32px">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="leadcompanyname" :searchable="true" v-model="newLead.lead_company" :options="leadCompanies" :loading="isLoading.leadcompanyname" @open="getLeadCompanies" @search-change="getLeadCompanies" @close="dropdownClosed" @select="leadCompanyNameSelected" :custom-label="leadCompanyNameLabel" placeholder="Search or Select Lead Company Name">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreLeadCompanies" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Companies Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div class="d-flex">
                                <div style="width:60%">
                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                        Date
                                    </span>
                                    <div class="d-flex align-items-center mt-5 mr-1">
                                        <date-picker v-if="date_iso" class="meetinfdatetime mx-left calendar-edit-per mr-1" format="DD/MM/YYYY"  type="date" lang="en" :clearable="false" :editable="false" v-model="newLead.lead_start_date" confirm confirm-text="APPLY"></date-picker>
                                        <date-picker v-else class="meetinfdatetime mx-left calendar-edit-per mr-1" format="DD/MM/YYYY"  type="date" lang="en" :clearable="false" :editable="false" :value-type="valueType" v-model="newLead.lead_start_date" confirm confirm-text="APPLY"></date-picker>
                                        <span>
                                            <i class="icon icon-check-circle fs-30 mx-2" style="color: #ff9a06;"></i>
                                        </span>
                                    </div>
                                </div>
                                <div style="width:40%">
                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                        Time
                                        <sup class="fs-14 ml-02 mandatory">
                                            <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                                <div slot="content" style="color: #fff; font-size: 12px;">
                                                    <span style="font-weight: 600;">Default System Time Zone is applied. <br> <br> Time Zone: (GMT+05:30) Chennai, <br> Kolkata, Mumbai, New Delhi</span>
                                                </div>
                                                <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                            </el-tooltip>
                                        </sup>
                                    </span>
                                    <div class="d-flex align-items-center mt-4">
                                        <date-picker v-if="date_iso" class="mx-left meetinfdatetime calendar-down-arrow-grey" format="hh:mm a" type="time" placeholder="HH:MM" lang="en" :clearable="false" :editable="false" v-model="newLead.lead_start_date" :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                        <date-picker v-else class="mx-left meetinfdatetime calendar-down-arrow-grey" format="hh:mm a" type="time" :value-type="valueType" placeholder="HH:MM" lang="en" :clearable="false" :editable="false" v-model="newLead.lead_start_date" :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                        <span>
                                            <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Conventional
                                <sup class="fs-14 ml-2 mandatory">
                                    <el-tooltip effect="dark" placement="left">
                                        <div slot="content" style="color: #fff; font-size: 12px;">
                                            <span style="font-weight: 600;">Fields will be enabled if Lead Source <br> (Channel) is Conventional</span>
                                        </div>
                                        <i class="icon-information text-white" style="font-size: 15px;"></i>
                                    </el-tooltip>
                                </sup>
                            </div>
                        </div>
                        <div  class="col-lg-8 col-md-8 col-sm-8">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 mt-6">
                                    <div>
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                            Location Introduced
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="form-group gMap" style="width: 90%; padding-top: 20px">
                                                <gmap-autocomplete class="input-white" id="autocompleteInput" :value="locationIntroduced" @place_changed="setPlace" placeholder="Enter Location" style="padding: 6px 32px 6px 12px !important;background-color: transparent;height:44px !important;text-overflow:ellipsis;overflow:hidden;"></gmap-autocomplete>
                                                <el-tooltip class="item" effect="dark" placement="top">
                                                    <img src="/static/images/images-new-theme/icons/marker_pin.svg" style="position: absolute;right: 12px;bottom: 12px;" />
                                                </el-tooltip>
                                            </div>
                                            <div class="ml-3 mr-1" style="cursor: pointer; width: 10%; margin-top: 18px" @click="getLocation">
                                                <img src="/static/images/images-new-theme/icons/gps-white.svg" style="height: 40px;" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 mt-6">
                                    <div>
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                            Lead Contact Via
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :searchable="true" v-model="newLead.lead_type" :options="organisationSettings.hasOwnProperty('leads_settings') ? organisationSettings.leads_settings.lead_type : []" @search-change="searchLeadType" placeholder="Search or Select Lead Contact Via">
                                                    <template slot="afterList">
                                                        <div class="add-vendor fw-500" v-if="add_leadtype" @click="addLeadType()">
                                                            Add Lead Contact Via <span class="text-secondary fw-500">'{{add_leadtype}}'</span>
                                                            <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                        </div>
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">No Lead Contact Via Found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <span class="pointer" @click="changeView()">
                                                <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-5" style="width:20px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 mt-6">
                                    <div class="w-100">
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                            Referred By
                                        </span>
                                        <div class="d-flex align-items-center w-100">
                                            <div class="w-100">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" :searchable="true" v-model="newLead.referred_by" :options="referredBy" :loading="isLoading.referredby" @open="getReferredBy" @search-change="getReferredBy" @close="dropdownClosed" :custom-label="referredByLabel" placeholder="Search or Select Referred By">
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="getMoreReferredBy" />
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">No Meetingcall Found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 mt-6">
                                    <div>
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                            Meeting Type
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" :searchable="true" v-model="newLead.meeting_type" :options="organisationSettings.hasOwnProperty('leads_settings') ? organisationSettings.leads_settings.meeting_type : []" @search-change="searchMeetingType" placeholder="Search or Select Meeting Type">
                                                    <template slot="afterList">
                                                        <div class="add-vendor fw-500" v-if="add_meetingtype" @click="addMeetingType()">
                                                            Add Meeting Type <span class="text-secondary fw-500">'{{add_meetingtype}}'</span>
                                                            <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                        </div>
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">No Meeting Type Found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <span class="pointer" @click="changeView()">
                                                <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-5" style="width:20px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="newLead.lead_source == 'Conventional'" class="col-lg-4 col-md-4 col-sm-12 mt-6">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600" style="padding-top:2px">
                                    Secondary Attendees
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect-long greyblack no-default-icon mt-4" name="meetingcall" :searchable="true" v-model="newLead.lead_secondary_attendees" :options="secondaryAttendees" :loading="isLoading.secondaryattendee" @open="getSecondaryAttendee" @search-change="getSecondaryAttendee" @close="dropdownClosed" track-by="_id" :custom-label="secondaryAttendeesLabel" :multiple="true" placeholder="Enter Secondary Attendees">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreSecondaryAttendee" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Attendees Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="newLead.lead_source == 'Social Media'" class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Social Media
                                <sup class="fs-14 ml-1 mandatory">
                                    <el-tooltip effect="dark" placement="left">
                                        <div slot="content" style="color: #fff; font-size: 12px;">
                                            <span style="font-weight: 600;">Fields will be enabled if Lead Source <br> (Channel) is Social Media</span>
                                        </div>
                                        <i class="icon-information text-white" style="font-size: 15px;"></i>
                                    </el-tooltip>
                                </sup>
                            </div>
                        </div>
                        <div v-if="newLead.lead_source == 'Social Media'" class="col-12">
                            <div class="row" v-for="(social,index) in newLead.social_media" :key="index">
                                <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                    <div>
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                            Social Media Type
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" :searchable="true" v-model="social.account_type" :options="organisationSettings.leads_settings.social_media_type" @search-change="searchSocialMediaType" placeholder="--Select--">
                                                    <template slot="afterList">
                                                        <div class="add-vendor fw-500" v-if="add_socialmedia" @click="addSocialMediaType()">
                                                            Add Social Media Type <span class="text-secondary fw-500">'{{add_socialmedia}}'</span>
                                                            <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                        </div>
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">No Social Media Type Found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <span class="pointer" @click="changeView()">
                                                <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-5" style="width:20px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 mt-5">
                                    <span class="fs-14 fw-600" style="color: #005dae;">
                                        Links/URL
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <input :name="'sociallink'+index" v-validate="'url'" style="margin-top:19px;" class="inputFieldNew" type="text" v-model="social.account_url" :style="index+1 < newLead.social_media.length ? 'margin-right: 46px' : ''" placeholder="Enter Links/URL" />
                                        <i v-if="newLead.social_media.length > 1" @click="removeSocialMedia(index)" class="icon-minus-circle ml-5" style="color: #c93254; font-size: 25px; margin-top: 22px"></i>
                                        <i v-if="index+1 == newLead.social_media.length" @click="addSocialMedia" class="icon-plus-circle ml-5" style="color: #008a63; font-size: 25px; margin-top: 22px"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('sociallink'+index)">Please Enter a Valid Link/URL</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-outer mb-3">
                    <span class="fw-500">Lead Company Data</span>
                    <span class="pointer" @click="showHideLeadCompanyData">
                        <i v-if="leadCompanyDataTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="leadCompanyDataTab">
                    <div class="row" v-for="(leadTarget,index) in newLead.leads_target" :key="index">
                        <div class="col-12 mt-8 header-inner">
                            <div class="d-flex align-items-center">
                                Lead Target - {{ index + 1 }}
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Fiscal Year
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div style="width: 90%">
                                        <div class="fiscalYearDropdown" style="background-color: transparent !important;">
                                            <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown" @visible-change="dropdownTriggered">
                                                <span class="filters mr-1 w-100">
                                                    <span v-if="leadTarget.fiscal_year">{{leadTarget.fiscal_year}}</span>
                                                    <span v-else>Fiscal Year</span>
                                                    <span style="position:absolute;right:0px">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg" alt="">
                                                    </span>
                                                </span>
                                                <el-dropdown-menu slot="dropdown" class="fiscal-year-el">
                                                    <el-dropdown-item class="d-flex justify-content-between align-items-center">
                                                        <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                                                        <span style="font-size: 12px; font-weight: 400">{{years_to_set[0]}} - {{years_to_set[5]}}</span>
                                                        <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                                                    </el-dropdown-item>
                                                    <el-dropdown-item class="d-flex flex-column justify-content-center align-items-center">
                                                        <span :class="{ 'selectedYear':yearSelected == `${years_to_set[0]}-${years_to_set[1]}` }" @click="yearSelected = years_to_set[0] + '-' + years_to_set[1]">{{years_to_set[0]}} - {{years_to_set[1]}}</span>
                                                        <span :class="{ 'selectedYear':yearSelected == `${years_to_set[1]}-${years_to_set[2]}` }" @click="yearSelected = years_to_set[1] + '-' + years_to_set[2]">{{years_to_set[1]}} - {{years_to_set[2]}}</span>
                                                        <span :class="{ 'selectedYear':yearSelected == `${years_to_set[2]}-${years_to_set[3]}` }" @click="yearSelected = years_to_set[2] + '-' + years_to_set[3]">{{years_to_set[2]}} - {{years_to_set[3]}}</span>
                                                        <span :class="{ 'selectedYear':yearSelected == `${years_to_set[3]}-${years_to_set[4]}` }" @click="yearSelected = years_to_set[3] + '-' + years_to_set[4]">{{years_to_set[3]}} - {{years_to_set[4]}}</span>
                                                        <span :class="{ 'selectedYear':yearSelected == `${years_to_set[4]}-${years_to_set[5]}` }" @click="yearSelected = years_to_set[4] + '-' + years_to_set[5]">{{years_to_set[4]}} - {{years_to_set[5]}}</span>
                                                        <a href="javascript:;" class="btn btn-new-primary btn-xsm mt-2 mb-4" @click="yearClicked(index)">Apply</a>
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="showFiscalError">Fiscal Year is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Customer Name
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="">
                                    <div class="w-100 d-flex align-items-center">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :name="'leadtargetcompanyname'+index" :searchable="true" v-model="leadTarget.lead_company" :options="leadTargetCompanyNames" :loading="isLoading.leadtargetcompanyname" @open="getLeadTargetCompanyNames" @search-change="getLeadTargetCompanyNames" @close="dropdownClosed" :custom-label="leadTargetCompanyNameLabel" @select="leadTargetCompanyNameSelected($event,index)" placeholder="Search or Select Customer Name">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreLeadTargetCompanyNames" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Customer Name Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06;"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadtargetcompanyname'+index)">Customer Name is Required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Contact Name
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="">
                                    <div class="w-100 d-flex align-items-center">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :name="'leadtargetcontactname'+index" :searchable="true" v-model="leadTarget.lead_user_reference" :options="leadTargetContactNames" :loading="isLoading.leadtargetcontactname" @open="getLeadTargetContacts" @search-change="getLeadTargetContacts" @close="dropdownClosed" :custom-label="leadTargetContactNameLabel" placeholder="Search or Select Contact Name">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreLeadTargetContacts" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Contact Name Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06;"></i>
                                    </div>
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadtargetcontactname'+index)">Contact Name is Required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Branch Name
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :name="'leadtargetbranchname'+index" :searchable="true" v-model="leadTarget.branch" :options="leadTargetBranches" :loading="isLoading.leadtargetbranchname" :custom-label="leadTargetBranchNameLabel" @open="getLeadTargetBranches(index)" @select="leadTargetBranchSelected($event,index)" label="name" placeholder="Search or Select Branch Name">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Branch Name Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadtargetbranchname'+index)">Branch Name is Required</span>
                                    </div>
                                    <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06; opacity: 0; visibility: hidden;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Department Name
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :name="'leadtargetdepartmentname'+index" :searchable="true" v-model="leadTarget.department" :options="leadTargetDepartments" :loading="isLoading.leadtargetdepartmentname" :custom-label="leadTargetDepartmentNameLabel" placeholder="Search or Select Department Name">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Department Name Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadtargetdepartmentname'+index)">Department Name is Required</span>
                                    </div>
                                    <i class="icon icon-check-circle fs-30 ml-2 mt-5" style="color: #ff9a06; opacity: 0; visibility: hidden;"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Product Interest
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">The values are listed from the CRM <br> Product page</span>
                                            </div>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100" style="margin-right: 32px">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" :name="'leadtargetproductinterest'+index" :searchable="true" v-model="leadTarget.product" :options="leadTargetproductInterests" :loading="isLoading.leadtargetproductinterests" @open="getProductInterests" @search-change="getProductInterests" @close="dropdownClosed" label="product_name" placeholder="Search or Select Product Interest">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreProductInterests" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Product Interest Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('leadtargetproductinterest'+index)">Product Interest is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div class="d-flex align-items-center">
                                <div style="width:65%">
                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                        Transaction Closing Date
                                    </span>
                                    <div class="d-flex align-items-center mt-5 mr-1">
                                        <date-picker v-if="date_iso" class="meetinfdatetime mx-left calendar-edit-per mr-1" format="DD/MM/YYYY" type="date" lang="en" v-model="leadTarget.transaction_end_date" :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                        <date-picker v-else class="meetinfdatetime mx-left calendar-edit-per mr-1" format="DD/MM/YYYY" type="date" :value-type="valueType" lang="en" v-model="leadTarget.transaction_end_date" :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                    </div>
                                </div>
                                <div style="width:25%">
                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                        Time
                                        <sup class="fs-14 ml-1 mandatory">
                                            <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                                <div slot="content" style="color: #fff; font-size: 12px;">
                                                    <span style="font-weight: 600;">Default System Time Zone is applied. <br> <br> Time Zone: (GMT+05:30) Chennai, <br> Kolkata, Mumbai, New Delhi</span>
                                                </div>
                                                <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                            </el-tooltip>
                                        </sup>
                                    </span>
                                    <div class="d-flex align-items-center mt-4">
                                        <date-picker v-if="date_iso" class="mx-left meetinfdatetime calendar-down-arrow-grey mr-1" format="hh:mm" type="time" placeholder="HH:MM" lang="en" v-model="leadTarget.transaction_end_date" :clearable="false" :editable="false" :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                        <date-picker v-else class="mx-left meetinfdatetime calendar-down-arrow-grey mr-1" format="hh:mm" type="time" placeholder="HH:MM" :value-type="valueType" lang="en" v-model="leadTarget.transaction_end_date" :clearable="false" :editable="false" :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Unit of Measure
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100" style="margin-right: 32px">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall"
                                        :searchable="true"
                                        v-model="leadTarget.uom"
                                        :options="uoms"
                                        :loading="isLoading.leadtargetuoms"
                                        @open="getUoms"
                                        @search-change="getUoms"
                                        @close="dropdownClosed"
                                        placeholder="Search or Select Unit of Measure">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreUoms" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Unit of Measure Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Transaction Value
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="d-flex align-items-center w-100 mr-0" style="margin-right:-89px">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" style="width: 6em" name="transactionsymbol" :searchable="true" v-model="leadTarget.transaction_value.symbol" :options="currency" @select="onCurrencySelect" placeholder="">
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Transaction Value Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                         <input class="inputFieldNew mt-5 w-100 mr-8 ml-3" type="number" v-model.number="leadTarget.transaction_value.value" placeholder="Enter Transaction Value" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(link,index) in leadTarget.company_links" :key="index">
                            <span class="fs-14 fw-600" style="color: #005dae;">
                                Links/URL
                            </span>
                            <div class="d-flex align-items-center">
                                <input :name="'link'+index" v-validate="'url'" class="inputFieldNew mt-6" type="text" v-model="leadTarget.company_links[index]" placeholder="Enter Referred By" />
                                <i v-if="index > 0" class="icon-minus-circle ml-5" @click="leadTarget.company_links.splice(index,1)" style="color: #c93254; font-size: 25px; margin-top: 22px"></i>
                                <i v-if="index+1 == leadTarget.company_links.length" @click="leadTarget.company_links.push('')" class="icon-plus-circle ml-5" style="color: #008a63; font-size: 25px; margin-top: 22px"></i>
                            </div>
                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('link'+index)">Please Enter a Valid Link/URL</span>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                            <div class="table-responsive mt-10" style="overflow-x:auto;">
                                <table class="table-sales w-100">
                                    <thead>
                                        <tr style="background-color: #0b61fc;">
                                            <th>Month</th>
                                            <th>Jan</th>
                                            <th>Feb</th>
                                            <th>Mar</th>
                                            <th>Apr</th>
                                            <th>May</th>
                                            <th>June</th>
                                            <th>July</th>
                                            <th>Aug</th>
                                            <th>Sep</th>
                                            <th>Oct</th>
                                            <th>Nov</th>
                                            <th>Dec</th>
                                            <th>Transaction<br>Target</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Units
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jan">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.feb">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.mar">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.apr">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.may">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jun">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jul">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.aug">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.sept">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.oct">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.nov">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.dec">
                                            </td>
                                            <td style="background-color:#dfe8f4">{{ leadTarget.target.jan + leadTarget.target.feb + leadTarget.target.mar + leadTarget.target.apr + leadTarget.target.may + leadTarget.target.jun + leadTarget.target.jul + leadTarget.target.aug + leadTarget.target.sept + leadTarget.target.oct + leadTarget.target.nov + leadTarget.target.dec }}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Value({{currency_symbol}})
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jan_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.feb_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.mar_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.apr_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.may_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jun_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.jul_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.aug_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.sept_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.oct_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.nov_quantity">
                                            </td>
                                            <td>
                                                <input type="text" class="inputFieldSalesTable" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model.number="leadTarget.target.dec_quantity">
                                            </td>
                                            <td style="background-color:#dfe8f4">{{ leadTarget.target.jan_quantity + leadTarget.target.feb_quantity + leadTarget.target.mar_quantity + leadTarget.target.apr_quantity + leadTarget.target.may_quantity + leadTarget.target.jun_quantity + leadTarget.target.jul_quantity + leadTarget.target.aug_quantity + leadTarget.target.sept_quantity + leadTarget.target.oct_quantity + leadTarget.target.nov_quantity + leadTarget.target.dec_quantity }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex flex-wrap justify-content-end align-items-center">
                                <span class="d-flex justify-content-end align-items-center mr-4 mt-6">
                                    <span class="fw-600 text-secondary fs-15 mr-2">Send to Sales Forecast</span>
                                    <span class="fw-600 text-secondary fs-15 mr-2">No</span>
                                    <el-switch class="routers" v-model="leadTarget.to_sales_forecast"  active-color="#005dae" inactive-color="#bcb8b8"></el-switch>
                                    <span class="fw-600 text-secondary fs-15 ml-2">Yes</span>
                                </span>
                                <button class="btn btn-des-small mr-4 mt-6" style="color: #fff; background: #008a63; border: 1px solid #008a63" @click="addLeadTarget" v-if="index + 1 == newLead.leads_target.length">+ Add Lead Target</button>
                                <button class="btn btn-des-small mr-4 mt-6" style="color: #fff; background: #d51650; border: 1px solid #d51650" @click="deleteLeadTarget(index)" v-if="newLead.leads_target.length > 1">- Delete Lead Target</button>
                                <button class="btn btn-des-small mt-6" style="color: #fff; background: #00448b; border: 1px solid #00448b" @click="resetLeadTarget(index)">Reset</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                            <div class="header-inner">
                                <div class="d-flex align-items-center">
                                    Connect Call Reports
                                </div>
                            </div>
                            <div style="height: 15em; border: 1px solid #676767; border-radius: 5px; margin-top: 20px; padding: 10px;">
                                <div class="w-100">
                                    <span class="call-report-number" v-for="(call_report,index) in newLead.lead_call_reports" :key="index">
                                        {{ call_report.call_report_number }}
                                        <i class="icon icon-close text-white fs-18 pointer" @click="deleteCallReport(index)"></i>
                                    </span>
                                </div>
                                <div v-if="newLead.lead_call_reports.length == 0" class=" w-100 d-flex justify-content-center flex-column align-items-center" style="color: rgba(103, 103, 103, 0.84);">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/call_report_new.svg">
                                    <div class="fw-500">There are no Call Reports found!</div>
                                    <div>Please click the blue button to connect the Call Reports</div>
                                </div>
                            </div>
                            <div class="float-right">
                                <button class="btn btn-des-small mt-6" style="color: #fff; background: #00448b; border: 1px solid #00448b" @click="$modal.show('createLeadsAddCallReport')">Select Call Reports</button>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                            <div class="header-inner">
                                <div class="d-flex align-items-center">
                                    Reminders
                                </div>
                            </div>
                            <div style="height: 15em; border: 1px solid #676767; border-radius: 5px; margin-top: 20px; padding: 10px;">
                                <div class="row px-4">
                                    <div class="col-6 mb-2" v-for="(reminder,index) in newLead.lead_reminders" :key="index">
                                        <div class="reminders">
                                            <div class="d-flex">
                                                <div class="calendar">
                                                    <span>{{ reminder.event_schedule.start_date.month || "-" }}</span>
                                                    <span class="fw-600 fs-18">{{ moment(reminder.event_schedule.start_date).format("DD") || "-" }}</span>
                                                    <span>{{ moment(reminder.event_schedule.start_date).format("YYYY") || "-" }}</span>
                                                </div>
                                                <div class="d-flex flex-column ml-2">
                                                    <span class="fw-600">{{ reminder.name || '-' }}</span>
                                                    <span class="fw-600" style="color: #939393; font-size: 10px">{{ moment(reminder.event_schedule.start_time).format('LT') || "-" }}, {{ reminder.event_schedule.start_date.day || "-" }}</span>
                                                    <div class="d-flex align-items-center flex-wrap">
                                                        <div class="pl-1" v-for="(remind_before,index1) in reminder.remind_before" :key="index1" style="color: #939393; font-size: 8px;line-height: 1.2;">{{remind_before.number || "-" }} {{remind_before.gap || "-" }}</div>
                                                        <div class="pl-1" style="font-size: 10px;color: #939393; line-height: 1.2;">to Go!</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="pointer" @click="editReminder(index)">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/edit-dark.svg" width="12px" class="pointer">
                                                </span>
                                                <span class="pointer" @click="deleteReminder(index)">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg" width="8px" class="ml-2 pointer">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="newLead.lead_reminders.length == 0" class="d-flex justify-content-center flex-column align-items-center  w-100" style="color: rgba(103, 103, 103, 0.84);">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminder_new.svg">
                                        <div class="fw-500">You don't have any Reminders yet!</div>
                                        <div>Please click the green button to add reminder</div>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right">
                                <button class="btn btn-des-small mt-6" style="color: #fff; background: #008a63; border: 1px solid #008a63" @click="addReminders">+ Add Reminders</button>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                            <div class="header-inner">
                                <div class="d-flex align-items-center">
                                    Notes
                                </div>
                            </div>
                            <textarea-autosize class="digi-textarea white-background bordered mt-5" placeholder="Add Notes" v-model="newLead.lead_notes" style="height: 14em; overflow: auto;" />
                        </div>
                    </div>
                </div>
                <div class="header-outer mb-3">
                    <span class="fw-500">Attachments</span>
                    <span class="pointer" @click="showHideAttachments">
                        <i v-if="attachmentsTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                        <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                    </span>
                </div>
                <div class="inner-div" v-if="attachmentsTab">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                            <span class="d-flex justify-content-center text-white fw-600 fs-12 py-4" style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">ADD ATTACHMENTS</span>
                            <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0" style="height: 18em; background: #f5f5f5; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg" style="width: 3.5em; height: 3.5em">
                                <span class="fs-12 fw-500 mt-2">
                                    Drag and Drop File
                                    <sup class="fs-14 ml-02 mandatory">
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">Select a Lead Contact if already exists <br> in the dropdown, else add a Lead <br> Contact here.</span>
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <!-- , .htm, .html, .flv -->
                                <span>File Type : Document - [ .doc, .docx, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx <span style="color: #00448b">- ( File Limit : 10 Files of 10 MB Each ) ]</span></span>
                                <span>File Type : Image- [ .bmp, .gif, .jpeg, .png, .svg, .tiff <span style="color: #00448b">- ( File Limit : 10 files of 10 mb each )]</span></span>
                                <span>File Type : Video/Audio -[ .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv <span style="color: #00448b">- ( File Limit : 10 files of 10 mb each ) ]</span></span>
                                <span class="fs-12 fw-500 mt-2">or</span>
                                <file-upload
                                    class="choose-file btn btn-des-small mt-2"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    @input-file="uploadAttachment"
                                    ref="upload"
                                    style="text-transform: none !important; color: #fff; background: #1c61c2; border: 1px solid #1c61c2; width: 8em;">
                                    Browse
                                </file-upload>
                            </div>
                            <div class="attachmentsdiv p-4 my-2" v-for="(attachment,index) in newLead.attachments" :key="index">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                            <img v-else-if="attachment.name.endsWith('.png')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg" />
                                            <img v-else-if="attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" />
                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                        </div>
                                        <div class="col">
                                            <div class="d-flex justify-content-between">
                                                <el-tooltip :content="attachment.name" placement="top">
                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">{{attachment.name}}</div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="attachment.uploading || attachment.url == undefined" >
                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploaded</div>
                                                <div class="fw-500">({{attachment.size | prettyBytes}})</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="attachment.uploading || attachment.url == undefined" class="pointer">
                                        <i class="icon icon-close fs-16 closeAttachment" @click="deleteAttachment(index)"></i>
                                    </div>
                                    <div v-else class="pointer">
                                        <i class="icon icon-close fs-16 closeAttachment" @click="deleteAttachment(index)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center mb-4" :class="attachmentsTab ? '' : 'mt-10'">
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #d51650; border: 1px solid #d51650" @click="cancel">Cancel</button>
                    <!-- <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #008a63; border: 1px solid #008a63" @click="save('draft')">Save</button> -->
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #3f3f3f; background: #ffcb73; border: 1px solid #ffcb73; width: 8em" @click="save('draft')">Save As Draft</button>
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #1c61c2; border: 1px solid #1c61c2" @click="next('classification')">Next</button>
                </div>
            </div>
            <div class="main-div mt-4" v-if="classification">
                <div class="header-outer">
                    <span class="fw-500">Lead Classification</span>
                </div>
                <div class="inner-div">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Status
                                    <sup class="fs-14 ml-1 mandatory">
                                        *
                                    </sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect v-validate="'required'" class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="status" :searchable="true" v-model="classify_status" :options="classify_status_option" @select="classifyStatusSelected" placeholder="Search or Select Status"></multiselect>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('status')">This Field is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Classification
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" :searchable="true" v-model="classify_classification" @select="classifyClassificationSelected" :options="classify_classification_option" placeholder="Search or Select Classification"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 mt-5" v-if="is_classification_selected && is_status_selected">
                            <div>
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                    Sales Person
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-5" name="meetingcall" label="name" :searchable="true" v-model="classify_sales_person" :options="classify_sales_person_option" :loading="isLoading.sales_person" @open="getSalesPerson" @search-change="getSalesPerson" placeholder="Search or Select Sales Person">
                                            <template slot="afterList">
                                                <div v-observe-visibility="getMoreSalesPerson" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">No Sales Person Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center mb-4" :class="attachmentsTab ? '' : 'mt-10'">
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #d51650; border: 1px solid #d51650" @click="previous('lead')">Previous</button>
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #008a63; border: 1px solid #008a63" @click="save('draft')">Save</button>
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #3f3f3f; background: #ffcb73; border: 1px solid #ffcb73; width: 8em" @click="save('draft')">Save As Draft</button>
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #1c61c2; border: 1px solid #1c61c2" @click="save('actual')">Submit</button>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <create-leads-add-call-report-modal modal_name="createLeadsAddCallReport" :lead_call_reports="newLead.lead_call_reports"></create-leads-add-call-report-modal>
        <create-leads-add-edit-reminder v-if="create_leads_add_edit" modal_name="createLeadsAddEditReminder" :add_edit_reminder="add_edit_reminder" :leadreminder="leadreminder" @hideReminderPop="hideReminderPop" @saveReminder="saveReminder" @editReminderConfirm="editReminderConfirm"></create-leads-add-edit-reminder>
        <success-message v-if="success_lead" message="Your Lead data has been successfully submitted." modal_name="success-message" @hideSuccess="hideSuccess"></success-message>
    </div>
</template>

<script>
import CreateLeadsAddCallReportModal from "./CreateLeadsAddCallReportModal";
import CreateLeadsAddEditReminder from "./CreateLeadsAddEditReminder";
import SuccessMessage from "./SuccessMessage";
import { SweetModal } from 'sweet-modal-vue';
import globals from "./globals";
import currency from "./json/currency.json";
import uploadFileLeads from "./mixins/uploadFileLeads";
import { HalfCircleSpinner } from "epic-spinners";
import moment from "moment";
import axios from "axios";
import callreport from './mixins/callreport';
import { EventBus } from './eventBus/nav-bar-event';
export default {
    data() {
        const value2date = (dateRange) => {
            const date = new Date(dateRange)
            return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
        }
        const date2value = (date) => {
            return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
        }
        return {
            valueType: {
                value2date,
                date2value
            },
            date_iso: false,
            create_leads_add_edit: false,
            add_edit_reminder: '',
            callInProgress: false,
            is_classification_selected: false,
            is_status_selected: false,
            success_lead: false,
            sales_count: 0,
            count: 0,
            limit: 10,
            search_key: "",
            currency: [... new Set(currency.map(x =>  x.symbol ))],
            leadInformationTab: true,
            leadCompanyDataTab: true,
            attachmentsTab: true,
            organisationSettings: "",
            leadContacts: [],
            leadCompanies: [],
            leadCampaigns: [],
            leadTargetproductInterests: [],
            leadStatuses: [
                "Cold Lead",
                "Hot Lead",
                "Warm Lead"
            ],
            leadSources: [
                "Conventional",
                "Social Media"
            ],
            referredBy: [],
            secondaryAttendees: [],
            leadTargetCompanyNames: [],
            leadTargetContactNames: [],
            leadTargetBranches: [],
            leadTargetDepartments: [],
            uoms: [],
            isLoading: {
                leadcontactname: false,
                leadcompanyname: false,
                leadcampaignsource: false,
                referredby: false,
                secondaryattendee: false,
                leadtargetcompanyname: false,
                leadtargetcontactname: false,
                leadtargetbranchname: false,
                leadtargetdepartmentname: false,
                leadtargetuoms: false,
                leadtargetproductinterests: false,
                sales_person: false
            },
            locationIntroduced: "",
            newLead: {
                attachments: [],
                campaign_source: "",
                classification: {
                    classification: "",
                    sales_person: {},
                    status: ""
                },
                doc_status: "",
                lead_call_reports: [],
                lead_company: "",
                lead_notes: "",
                lead_reminders: [],
                lead_secondary_attendees: [],
                lead_source: "Conventional",
                lead_start_date: new Date(),
                lead_status: "",
                leads_target: [
                    {
                        branch: "",
                        company_links: [""],
                        department: "",
                        fiscal_year: "",
                        lead_company: "",
                        lead_user_reference: "",
                        product: "",
                        target: {
                            jan: 0,
                            jan_quantity: 0,
                            feb: 0,
                            feb_quantity: 0,
                            mar: 0,
                            mar_quantity: 0,
                            apr: 0,
                            apr_quantity: 0,
                            may: 0,
                            may_quantity: 0,
                            jun: 0,
                            jun_quantity: 0,
                            jul: 0,
                            jul_quantity: 0,
                            aug: 0,
                            aug_quantity: 0,
                            sept: 0,
                            sept_quantity: 0,
                            oct: 0,
                            oct_quantity: 0,
                            nov: 0,
                            nov_quantity: 0,
                            dec: 0,
                            dec_quantity: 0,
                        },
                        transaction_end_date: "",
                        transaction_value: {
                            symbol: "$",
                            value: 0
                        },
                        uom: "",
                        to_sales_forecast: false,
                    },
                ],
                lead_type: "",
                lead_user_email: "",
                lead_user_phone: {
                    country_code: "IN",
                    dial_code: "91",
                    phone_number: "",
                    phone_type: "personal"
                },
                lead_user_reference: "",
                location: {
                    address_type: "",
                    city: "",
                    country: "",
                    state: "",
                    street: ""
                },
                meeting_type: "",
                referred_by: "",
                title: "",
                social_media: [
                    {
                        account_id: "",
                        account_type: "",
                        account_url: "",
                        logo: ""
                    },
                ]
            },
            hide_el_dropdown: false,
            years_to_set: [],
            noFiscalYear: [],
            showFiscalError: false,
            yearSelected: "",
            meetingTypes: [],
            leadTypes: [],
            leadreminder: "",
            leadreminderindex: "",
            lead:true,
            classification:false,
            classify_status:'',
            classify_status_option:['Qualified Lead','Active Lead','Non Qualified Lead','Pending Lead'],
            classify_classification:'',
            classify_classification_option:['Assigned','Reassigned','Unassigned'],
            classify_sales_person:'',
            classify_sales_person_option:[],
            add_title: '',
            add_campaign: '',
            add_leadtype: '',
            add_meetingtype: '',
            sales_search_key:'',
            add_socialmedia: '',
            skip_count: 0,
            success_msg:'',
            warning_msg:'',
            leads_settings_update: {},
            currency_symbol: '$'
        }
    },
    mixins: [uploadFileLeads, callreport],
    components: {
        CreateLeadsAddCallReportModal,
        CreateLeadsAddEditReminder,
        HalfCircleSpinner,
        SuccessMessage,
        SweetModal,
        // Toasted
    },
    methods: {
        changeView(){
            let sales = true
            let routeData = this.$router.resolve({name: 'Settings', query: {sales:sales}});
            window.open(routeData.href, '_blank');
        },
        onCurrencySelect(selectOption) {
            this.currency_symbol = selectOption;
        },
        hideSuccess() {
            this.success_lead = false;
            setTimeout(() => {
                this.$router.push("/listleads");
            }, 1000);
        },
        async addTitle(){
            alert(1)
            if(this.add_title){
                alert(this.add_title)
                this.leads_settings_update = this.organisationSettings.leads_settings
                this.leads_settings_update.title.push(this.add_title);
                try {
                    let param = {
                        leads_settings: this.leads_settings_update
                    }
                    let res = await this.$http.post("/organisation_settings/add", param);
                    if (res.data.status_id == 1) {
                        this.success_msg = res.data.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 1000);
                    }
                }
                catch(reason) {
                    this.warning_msg = reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
        },
        searchTitle(search_key) {
            let letters = /^[A-Za-z]+$/;
            if(search_key.match(letters)) {
                this.add_title = search_key;
            }
            else {
                this.add_title = ''
            }
        },
        async addCampaign(){
            if(this.add_campaign){
                this.leads_settings_update = this.organisationSettings.leads_settings
                // console.log(leads_settings_update)
                this.leads_settings_update.campaign_source.push(this.add_campaign);
                try {
                    let param = {
                        leads_settings: this.leads_settings_update
                    }
                    let res = await this.$http.post("/organisation_settings/add", param);
                    if (res.data.status_id == 1) {
                        this.success_msg = res.data.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 1000);
                    }
                }
                catch(reason) {
                    this.warning_msg = reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
        },
        searchCampaign(search_key) {
            let letters = /^[A-Za-z]+$/;
            if(search_key.match(letters)) {
                this.add_campaign = search_key;
            }
            else {
                this.add_campaign = ''
            }
        },
        async addLeadType(){
            if(this.add_leadtype){
                this.leads_settings_update = this.organisationSettings.leads_settings
                this.leads_settings_update.lead_type.push(this.add_leadtype);
                try {
                    let param = {
                        leads_settings: this.leads_settings_update
                    }
                    let res = await this.$http.post("/organisation_settings/add", param);
                    if (res.data.status_id == 1) {
                        this.success_msg = res.data.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 1000);
                    }
                }
                catch(reason) {
                    this.warning_msg = reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
        },
        searchLeadType(search_key) {
            let letters = /^[A-Za-z]+$/;
            if(search_key.match(letters)) {
                this.add_leadtype = search_key;
            }
            else {
                this.add_leadtype = ''
            }
        },
        async addMeetingType() {
            if(this.add_meetingtype){
                this.leads_settings_update = this.organisationSettings.leads_settings
                this.leads_settings_update.meeting_type.push(this.add_meetingtype);
                try {
                    let param = {
                        leads_settings: this.leads_settings_update
                    }
                    let res = await this.$http.post("/organisation_settings/add", param);
                    if (res.data.status_id == 1) {
                        this.success_msg = res.data.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 1000);
                    }
                }
                catch(reason) {
                    this.warning_msg = reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
        },
        searchMeetingType(search_key) {
            let letters = /^[A-Za-z]+$/;
            if(search_key.match(letters)) {
                this.add_meetingtype = search_key;
            }
            else {
                this.add_meetingtype = ''
            }
        },
        async addSocialMediaType() {
            if(this.add_socialmedia){
                this.leads_settings_update = this.organisationSettings.leads_settings
                this.leads_settings_update.social_media_type.push(this.add_socialmedia);
                try {
                    let param = {
                        leads_settings: this.leads_settings_update
                    }
                    let res = await this.$http.post("/organisation_settings/add", param);
                    if (res.data.status_id == 1) {
                        this.success_msg = res.data.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.success_modal.close();
                        }, 1000);
                    }
                }
                catch(reason) {
                    this.warning_msg = reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
        },
        searchSocialMediaType(search_key) {
            let letters = /^[A-Za-z]+$/;
            if(search_key.match(letters)) {
                this.add_socialmedia = search_key;
            }
            else {
                this.add_socialmedia = ''
            }
        },
        goBack(){
            this.$router.push("/listleads");
        },
        next(val) {
            this.newLead.leads_target.forEach((x,index) => {
                if (!x.fiscal_year) {
                    this.noFiscalYear.push(index);
                }
            });
            this.$validator.validateAll().then(result => {
                if (result && !this.noFiscalYear.length) {
                    this.showFiscalError = false;
                    this.selectTab(val);
                }
                else {
                    if(!this.noFiscalYear.length) {
                        this.showFiscalError = false;
                    }
                    else {
                        this.showFiscalError = true;
                    }
                }
            })
        },
        previous(obj) {
            if(obj == 'lead'){
                this.lead = true
                this.classification = false
            }else if(obj == 'classification'){
                this.lead = false
                this.classification = true
            }
        },
        selectTab(obj){
            if(obj == 'lead'){
                this.lead = true
                this.classification = false
            }else if(obj == 'classification'){
                this.lead = false
                this.classification = true
            }
        },
        moment(date) {
            return moment(date);
        },
        yearNext() {
            let year = this.years_to_set[5];
            this.years_to_set = [];
            for (let i = 0; i < 6; i++) {
                this.years_to_set.push(year + i);
            }
        },
        yearPrev() {
            let year = this.years_to_set[0];
            this.years_to_set = [];
            for (let i = 0; i < 6; i++) {
                this.years_to_set.push(year - i);
            }
            this.years_to_set.reverse();
        },
        yearClicked(index) {
            this.hide_el_dropdown = true;
            this.newLead.leads_target[index].fiscal_year = this.yearSelected;
            if (this.noFiscalYear.includes(index)) {
                this.noFiscalYear = this.noFiscalYear.filter(x => x != index);
            }
        },
        dropdownTriggered(event) {
            if (event) {
                this.hide_el_dropdown = false;
            }
        },
        showHideLeadInformation() {
            if (this.leadInformationTab) {
                this.leadInformationTab = false;
            } else {
                this.leadInformationTab = true;
            }
        },
        showHideLeadCompanyData() {
            if (this.leadCompanyDataTab) {
                this.leadCompanyDataTab = false;
            } else {
                this.leadCompanyDataTab = true;
            }
        },
        showHideAttachments() {
            if (this.attachmentsTab) {
                this.attachmentsTab = false;
            } else {
                this.attachmentsTab = true;
            }
        },
        leadContactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        leadTargetContactNameLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        leadCompanyNameLabel({company_details}) {
            return `${company_details.name}`;
        },
        leadTargetCompanyNameLabel({company_details}) {
            return `${company_details.name}`;
        },
        referredByLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        secondaryAttendeesLabel({employee_details}) {
            return `${employee_details.name}`;
        },
        leadTargetBranchNameLabel(branch) {
            return `${branch.name}`;
        },
        leadTargetDepartmentNameLabel(department) {
            return `${department}`;
        },
        dropdownClosed() {
            this.search_key = "";
            this.skip_count = 0;
        },
        classifyStatusSelected(selectedOption) {
            if(selectedOption) {
                this.is_status_selected = true
            }
        },
        classifyClassificationSelected(selectedOption) {
            if(selectedOption === 'Unassigned') {
                this.is_classification_selected = false
            }
            else {
                this.is_classification_selected = true
            }
        },
        async getSalesPerson(search_key) {
            this.isLoading.sales_person = true;
            let params = {
                skip: 0,
                limit: 10,
                company_id: this.loggedInUser.company_details._id,
                search_key: search_key ? search_key : this.sales_search_key,
                active_status: "active"
            }
            let res = await this.getEmployees(params);
            if (res.status_id == 1) {
                res.response.forEach(x=> {
                    this.classify_sales_person_option.push({
                        name: x.full_name,
                        _id: x._id
                    })
                })
                this.isLoading.sales_person = false;
            }
        },
        async getMoreSalesPerson(reached) {
            if (reached) {
                this.isLoading.sales_person = true;
                this.count += 1;
                let params = {
                    skip: this.sales_count,
                    limit: 10,
                    company_id: this.loggedInUser.company_details._id,
                    search_key: this.sales_search_key,
                    active_status: "active"
                };
                let res = await this.getEmployees(params);
                if (res.response.skip == this.sales_count) {
                    let tempFiles = res.response;
                    tempFiles.forEach(x => {
                        this.classify_sales_person_option.push({
                            name: x.full_name,
                            _id: x._id
                        });
                    });
                    this.sales_count += res.response.length;
                    this.isLoading.sales_person = false
                }
                this.isLoading.sales_person = false;
            }
        },
        leadContactNameSelected(selectedOption) {
            if(selectedOption.phone_number) {
                if(selectedOption.phone_number.phone_number) {
                    if (selectedOption.phone_number.phone_number.includes("0")) {
                        let phone = selectedOption.phone_number.phone_number.replace("0", "");
                        this.newLead.lead_user_phone.phone_number = phone;
                    } else if (selectedOption.phone_number.phone_number.includes("+91")) {
                        this.newLead.lead_user_phone.phone_number = selectedOption.phone_number.phone_number;
                    }
                }
            }
            this.newLead.lead_user_email = selectedOption.email_id || '';
            this.newLead.leads_target.forEach(x => {
                x.lead_user_reference = selectedOption || '';
                if(Object.keys(selectedOption.company_details).length) {
                    x.lead_company = selectedOption;
                }
                if(Object.keys(selectedOption.branch_details).length ) {
                    x.branch = selectedOption.branch_details;
                }
                x.department = selectedOption.department || '';
            });
            if(Object.keys(selectedOption.company_details).length) {
                this.newLead.lead_company = selectedOption;
            }
        },
        leadCompanyNameSelected(selectedOption) {

            // this.newLead[index].lead_company = {company_name: selectedOption.company_details.name,};

            // this.newLead.leads_target.forEach(x => {
            //     x.lead_company = {
            //         company_name: selectedOption.company_details.name,
            //     };
            // });
        },
        setPlace(place) {
            let address = place.formatted_address.split(", ");
            this.newLead.location.city = address[address.length - 3] || "";
            this.newLead.location.country = address[address.length - 1];
            let statezip = address[address.length - 2] ? address[address.length - 2].split(" ") : ["", ""];
            this.newLead.location.state = statezip[0].match(/^[a-zA-Z]+$/) ? statezip[0] : statezip[1].match(/^[a-zA-Z]+$/) ? statezip[1] : "";
            this.newLead.location.street = address[address.length - 4] || "";
            this.locationIntroduced = place.formatted_address;
        },
        getLocation() {
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
        },
        showLocation(position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
            .then(response => {
                let address = response.data.results[0].formatted_address.split(", ");
                this.newLead.location.city = address[address.length - 3] || "";
                this.newLead.location.country = address[address.length - 1];
                let statezip = address[address.length - 2] ? address[address.length - 2].split(" ") : ["", ""];
                this.newLead.location.state = statezip[0].match(/^[a-zA-Z]+$/) ? statezip[0] : statezip[1].match(/^[a-zA-Z]+$/) ? statezip[1] : "";
                this.newLead.location.street = address[address.length - 4] || "";
                this.locationIntroduced = response.data.results[0].formatted_address;
            })
            .catch(e => {
                // this.errors.push(e)
            });
        },
        errorHandler(err) {
            if (err.code == 1) {
                // alert("Error: Access is denied!");
            } else if (err.code == 2) {
                // alert("Error: Position is unavailable!");
            }
        },
        addSocialMedia() {
            this.newLead.social_media.push({
                account_id:"",
                account_type:"",
                account_url:"",
                logo:"",
            });
        },
        removeSocialMedia(index) {
            this.newLead.social_media.splice(index,1);
        },
        leadTargetCompanyNameSelected(selectedOption,index) {
            this.newLead.leads_target[index].lead_company = selectedOption;
            this.newLead.leads_target[index].branch = '';
            this.newLead.leads_target[index].department = '';
        },
        leadTargetBranchSelected(selectedOption,index) {
            this.newLead.leads_target[index].branch = selectedOption;
            this.leadTargetDepartments = selectedOption.departments;
        },
        addLeadTarget() {
            this.newLead.leads_target.push(
                {
                    branch: "",
                    company_links: [""],
                    department: "",
                    fiscal_year: "",
                    lead_company: "",
                    lead_user_reference: "",
                    product: "",
                    target: {
                        jan: 0,
                        jan_quantity: 0,
                        feb: 0,
                        feb_quantity: 0,
                        mar: 0,
                        mar_quantity: 0,
                        apr: 0,
                        apr_quantity: 0,
                        may: 0,
                        may_quantity: 0,
                        jun: 0,
                        jun_quantity: 0,
                        jul: 0,
                        jul_quantity: 0,
                        aug: 0,
                        aug_quantity: 0,
                        sept: 0,
                        sept_quantity: 0,
                        oct: 0,
                        oct_quantity: 0,
                        nov: 0,
                        nov_quantity: 0,
                        dec: 0,
                        dec_quantity: 0,
                    },
                    transaction_end_date: "",
                    transaction_value: {
                        symbol: "$",
                        value: 0
                    },
                    uom: "",
                    to_sales_forecast: false,
                },
            );
        },
        deleteLeadTarget(index) {
            this.newLead.leads_target.splice(index,1);
        },
        resetLeadTarget(index) {
            this.newLead.leads_target[index].branch = "";
            this.newLead.leads_target[index].company_links = [""];
            this.newLead.leads_target[index].department = "";
            this.newLead.leads_target[index].fiscal_year = "";
            this.newLead.leads_target[index].lead_company = "";
            this.newLead.leads_target[index].lead_user_reference = "";
            this.newLead.leads_target[index].product = "";
            this.newLead.leads_target[index].target = {
                jan: 0,
                jan_quantity: 0,
                feb: 0,
                feb_quantity: 0,
                mar: 0,
                mar_quantity: 0,
                apr: 0,
                apr_quantity: 0,
                may: 0,
                may_quantity: 0,
                jun: 0,
                jun_quantity: 0,
                jul: 0,
                jul_quantity: 0,
                aug: 0,
                aug_quantity: 0,
                sept: 0,
                sept_quantity: 0,
                oct: 0,
                oct_quantity: 0,
                nov: 0,
                nov_quantity: 0,
                dec: 0,
                dec_quantity: 0,
            };
            this.newLead.leads_target[index].transaction_end_date = "";
            this.newLead.leads_target[index].transaction_value = {
                symbol: "$",
                value: 0
            };
            this.newLead.leads_target[index].uom = "";
            this.newLead.leads_target[index].to_sales_forecast = false;
        },
        cancel() {
            this.$router.push("/listleads");
        },
        saveReminder(lead_reminder) {
            this.create_leads_add_edit = false;
            this.newLead.lead_reminders.push({
                event_schedule: {
                    start_date: lead_reminder.event_schedule.start_date,
                    start_time: lead_reminder.event_schedule.start_time
                },
                event_type: "Leads Event Reminder",
                name: lead_reminder.name || '',
                remind_before: [
                    {
                        gap: lead_reminder.remind_before[0].gap,
                        number: lead_reminder.remind_before[0].number
                    },
                    {
                        gap: lead_reminder.remind_before[1].gap,
                        number: lead_reminder.remind_before[1].number
                    },
                    {
                        gap: lead_reminder.remind_before[2].gap,
                        number: lead_reminder.remind_before[2].number
                    }
                ]
            });
            this.newLead.lead_reminders.forEach(x => {
                if ("event_schedule" in x) {
                    if (x.event_schedule.start_date){
                        let startDate = x.event_schedule.start_date;
                        let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                        let formattedDate = new Date(startDate.toString().replace(pattern,'$3-$2-$1'));
                        let time = x.event_schedule.start_time.toString().split(":");
                        let time0 = time[0].split(' ');
                        if (!x.event_schedule.start_date.hasOwnProperty("month")) {
                            Object.assign(x.event_schedule.start_date, {
                                month: formattedDate.toLocaleString('default', { month: 'short' }),
                            });
                        } else {
                            x.event_schedule.start_date.month = formattedDate.toLocaleString('default', { month: 'short' });
                        }
                        if (!x.event_schedule.start_date.hasOwnProperty("day")) {
                            Object.assign(x.event_schedule.start_date, {
                                day: formattedDate.toLocaleString('default', { weekday: 'long' }),
                            });
                        } else {
                            x.event_schedule.start_date.day = formattedDate.toLocaleString('default', { weekday: 'long' });
                        }
                        if (!x.event_schedule.start_time.hasOwnProperty("ampm")) {
                            Object.assign(x.event_schedule.start_time, {
                                ampm: time0[time0.length-1] >= 12 ? "pm" : "am",
                            });
                        } else {
                            x.event_schedule.start_time.ampm = time0[time0.length-1] >= 12 ? "pm" : "am";
                        }
                    }
                }
            });
        },
        editReminderConfirm(lead_reminder) {
            this.create_leads_add_edit = false;
            this.newLead.lead_reminders[this.leadreminderindex] = {
                event_schedule: {
                    start_date: lead_reminder.event_schedule.start_date,
                    start_time: lead_reminder.event_schedule.start_time
                },
                event_type: "Leads Event Reminder",
                name: lead_reminder.name,
                remind_before: [
                    {
                        gap: lead_reminder.remind_before[0].gap,
                        number: lead_reminder.remind_before[0].number
                    },
                    {
                        gap: lead_reminder.remind_before[1].gap,
                        number: lead_reminder.remind_before[1].number
                    },
                    {
                        gap: lead_reminder.remind_before[2].gap,
                        number: lead_reminder.remind_before[2].number
                    }
                ]
            };
            this.newLead.lead_reminders.forEach(x => {
                if ("event_schedule" in x) {
                    if (x.event_schedule.start_date){
                        let startDate = x.event_schedule.start_date;
                        let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                        let formattedDate = new Date(startDate.toString().replace(pattern,'$3-$2-$1'));
                        let time = x.event_schedule.start_date.toString().split(":");
                        let time0 = time[0].split(' ');
                        if (!x.event_schedule.start_date.hasOwnProperty("month")) {
                            Object.assign(x.event_schedule.start_date, {
                                month: formattedDate.toLocaleString('default', { month: 'short' }),
                            });
                        } else {
                            x.event_schedule.start_date.month = formattedDate.toLocaleString('default', { month: 'short' });
                        }
                        if (!x.event_schedule.start_date.hasOwnProperty("day")) {
                            Object.assign(x.event_schedule.start_date, {
                                day: formattedDate.toLocaleString('default', { weekday: 'long' }),
                            });
                        } else {
                            x.event_schedule.start_date.day = formattedDate.toLocaleString('default', { weekday: 'long' });
                        }
                        if (!x.event_schedule.start_time.hasOwnProperty("ampm")) {
                            Object.assign(x.event_schedule.start_time, {
                                ampm: time0[time0.length-1] >= 12 ? "pm" : "am",
                            });
                        } else {
                            x.event_schedule.start_time.ampm = time0[time0.length-1] >= 12 ? "pm" : "am";
                        }
                    }
                }
            });
        },
        deleteAttachment(index) {
            this.newLead.attachments.splice(index,1);
        },
        deleteCallReport(index) {
            this.newLead.lead_call_reports.splice(index,1);
        },
        save(type) {
            this.newLead.leads_target.forEach((x,index) => {
                if (!x.fiscal_year) {
                    this.noFiscalYear.push(index);
                }
            });
            this.$validator.validateAll().then(result => {
                if (result && !this.noFiscalYear.length) {
                    this.saveConfirm(type);
                }
            })
        },
        deleteCallReport(index) {
            this.newLead.lead_call_reports.splice(index,1);
        },
        hideReminderPop() {
            this.create_leads_add_edit = false;
        },
        addReminders() {
            this.create_leads_add_edit = true;
            this.add_edit_reminder = 'add';
            setTimeout(() => {
                this.$modal.show("createLeadsAddEditReminder");
            }, 500);
        },
        editReminder(index) {
            this.leadreminder = this.newLead.lead_reminders[index];
            this.add_edit_reminder = 'edit';
            this.leadreminderindex = index;
            this.create_leads_add_edit = true;
            setTimeout(() => {
                this.$modal.show("createLeadsAddEditReminder");
            }, 500);
        },
        deleteReminder(index) {
            this.newLead.lead_reminders.splice(index,1);
        },
        async getProductInterests(key) {
            this.isLoading.leadtargetproductinterests = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/digi_products/list", params);
            if (res.data.status_id == 1) {
                this.leadTargetproductInterests = res.data.response;
                this.leadTargetproductInterests = this.leadTargetproductInterests.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.leadTargetproductInterests.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.isLoading.leadtargetproductinterests = false;
                this.skip_count = res.data.response.length
            }
        },
        async getMoreProductInterests(reached) {
            if (reached) {
                this.isLoading.leadtargetproductinterests = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/digi_products/list", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.response;
                    tempFiles.forEach(el => {
                        this.leadTargetproductInterests.push(el);
                    });
                    this.leadTargetproductInterests = this.leadTargetproductInterests.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.leadTargetproductInterests.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.response.length;
                    this.isLoading.leadtargetproductinterests = false;
                }
            }
        },
        async getLeadTargetCompanyNames(key) {
            this.isLoading.leadtargetcompanyname = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.searchCompanies(params);
            if (res.status_id == 1) {
                res.response.forEach(x=> {
                    this.leadTargetCompanyNames.push({
                        company_details: {
                            name: x.company_name,
                            _id: x._id
                        }
                    });
                })
                this.leadTargetCompanyNames = this.leadTargetCompanyNames.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.leadTargetCompanyNames.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.response.length
                this.isLoading.leadtargetcompanyname = false;
            }
        },
        async getMoreLeadTargetCompanyNames(reached) {
            if (reached) {
                this.isLoading.leadtargetcompanyname = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.searchCompanies(params);
                if (res.skip == this.skip_count) {
                    let tempFiles = res.response;
                    tempFiles.forEach(el => {
                        this.leadTargetCompanyNames.push({
                            company_details: {
                                name: el.company_name,
                                _id: el._id
                            }
                        });
                    });
                    this.leadTargetCompanyNames = this.leadTargetCompanyNames.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.leadTargetCompanyNames.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.response.length;
                    this.isLoading.leadtargetcompanyname = false;
                }
            }
        },
        async getReferredBy(key) {
            this.referredBy = [];
            this.isLoading.referredby = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.referredBy.push(x);
                    }
                });
                this.referredBy = this.referredBy.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.referredBy.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.data.response.length
                this.isLoading.referredby = false;
            }
        },
        async getMoreReferredBy(reached) {
            if (reached) {
                this.isLoading.referredby = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.response;
                    tempFiles.forEach(el => {
                        if (el.hasOwnProperty("employee_details")) {
                            this.referredBy.push(el);
                        }
                    });
                    this.referredBy = this.referredBy.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.referredBy.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.response.length;
                    this.isLoading.referredby = false;
                }
            }
        },
        async getSecondaryAttendee(key) {
            this.secondaryAttendees = [];
            this.isLoading.secondaryattendee = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.secondaryAttendees.push(x);
                    }
                });
                this.secondaryAttendees = this.secondaryAttendees.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.secondaryAttendees.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.data.response.length
                this.isLoading.secondaryattendee = false;
            }
        },
        async getMoreSecondaryAttendee(reached) {
            if (reached) {
                this.isLoading.secondaryattendee = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.response;
                    tempFiles.forEach(el => {
                        if (el.hasOwnProperty("employee_details")) {
                            this.secondaryAttendees.push(el);
                        }
                    });
                    this.secondaryAttendees = this.secondaryAttendees.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.secondaryAttendees.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.response.length;
                    this.isLoading.secondaryattendee = false;
                }
            }
        },
        async getOrganisationSettings() {
            this.callInProgress = true;
            let res = await this.$http.get("/organisation_settings/list");
            if (res.data.status_id == 1) {
                this.organisationSettings = res.data.response;
                // this.leadTypes = this.organisationSettings.leads_settings.lead_type
                // this.meetingTypes = this.organisationSettings.leads_settings.meeting_type
                this.callInProgress = false;
            }
        },
        async getLeadContacts(key) {
            this.leadContacts = [];
            this.isLoading.leadcontactname = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.leadContacts.push(x);
                    }
                });
                this.leadContacts = this.leadContacts.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.leadContacts.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.data.response.length
                this.isLoading.leadcontactname = false;
            }
        },
        async getMoreLeadContacts(reached) {
            if (reached) {
                this.isLoading.leadcontactname = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.response;
                    tempFiles.forEach(el => {
                        if (el.hasOwnProperty("employee_details")) {
                            this.leadContacts.push(el);
                        }
                    });
                    this.leadContacts = this.leadContacts.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.leadContacts.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.response.length;
                    this.isLoading.leadcontactname = false;
                }
            }
        },
        async getLeadTargetContacts(key) {
            this.leadTargetContactNames = [];
            this.isLoading.leadtargetcontactname = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/shadow_employees/list/detailed", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    if (x.hasOwnProperty("employee_details")) {
                        this.leadTargetContactNames.push(x);
                    }
                });
                this.leadTargetContactNames = this.leadTargetContactNames.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.leadTargetContactNames.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.data.response.length
                this.isLoading.leadtargetcontactname = false;
            }
        },
        async getMoreLeadTargetContacts(reached) {
            if (reached) {
                this.isLoading.leadtargetcontactname = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post("/shadow_employees/list/detailed", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.response;
                    tempFiles.forEach(el => {
                        if (el.hasOwnProperty("employee_details")) {
                            this.leadTargetContactNames.push(el);
                        }
                    });
                    this.leadTargetContactNames = this.leadTargetContactNames.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.leadTargetContactNames.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.response.length;
                    this.isLoading.leadtargetcontactname = false;
                }
            }
        },
        async getLeadCompanies(key) {
            this.leadCompanies = [];
            this.isLoading.leadcompanyname = true;
            if (key) {
                this.search_key = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.searchCompanies(params);
            if (res.status_id == 1) {
                res.response.forEach(x => {
                    this.leadCompanies.push({
                        company_details: {
                            name: x.company_name,
                            _id: x._id
                        }
                    });
                });
                this.leadCompanies = this.leadCompanies.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.leadCompanies.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.response.length
                this.isLoading.leadcompanyname = false;
            }
        },
        async getMoreLeadCompanies(reached) {
            if (reached) {
                this.isLoading.leadcompanyname = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.searchCompanies(params);
                if (res.skip == this.skip_count) {
                    let tempFiles = res.response;
                    tempFiles.forEach(el => {
                        this.leadCompanies.push({
                            company_details: {
                                name: el.company_name,
                                _id: el._id
                            }
                        });
                    });
                    this.leadCompanies = this.leadCompanies.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.leadCompanies.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.response.length;
                    this.isLoading.leadcompanyname = false;
                }
            }
        },
        // async getLeadCampaigns() {
        //     this.leadCampaigns = [];
        //     this.isLoading.leadcampaignsource = true;
        //     let res = await this.$http.get("/campaign/list_campaign");
        //     if (res.data.status_id == 1) {
        //         res.data.response.forEach(x => {
        //             this.leadCampaigns.push(x);
        //         });
        //         this.isLoading.leadcampaignsource = false;
        //     }
        // },
        async getLeadTargetBranches(index) {
            if (this.newLead.leads_target[index].lead_company) {
                this.isLoading.leadtargetbranchname = true;
                let param = {
                    company_name: this.newLead.leads_target[index].lead_company.company_details.name,
                }
                let res = await this.$http.post("shadow_companies/get_branches", param);
                if (res.data.status_id == 1) {
                    this.leadTargetBranches = res.data.response;
                }
                this.isLoading.leadtargetbranchname = false;
            }
        },
        async getUoms(key) {
            this.isLoading.leadtargetuoms = true;
            if (key) {
                this.search_key = key;
            };
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
            };
            let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_unit_of_measurements", params);
            if (res.data.status_id == 1) {
                res.data.unit_of_measurements.forEach(x => {
                    this.uoms.push(x.name);
                });
                this.uoms = this.uoms.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.uoms.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.skip_count = res.data.unit_of_measurements.length
                this.isLoading.leadtargetuoms = false;
            }
        },
        async getMoreUoms(reached) {
            if (reached) {
                this.isLoading.leadtargetuoms = true;
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key,
                };
                let res = await this.$http.post(globals.SCM_API + "/fnb/scm/get_unit_of_measurements", params);
                if (res.data.skip == this.skip_count) {
                    let tempFiles = res.data.unit_of_measurements;
                    tempFiles.forEach(el => {
                        this.uoms.push(el.name)
                    });
                    this.uoms = this.uoms.filter((thing, index) => {
                        const payload = JSON.stringify(thing);
                        return index === this.uoms.findIndex(obj => {
                            return JSON.stringify(obj) === payload;
                        });
                    });
                    this.skip_count += res.data.unit_of_measurements.length;
                    this.isLoading.leadtargetuoms = false;
                }
            }
        },
        async saveConfirm(type) {
            this.callInProgress = true;
            if (this.newLead.lead_user_reference) {
                this.newLead.lead_user_reference = {
                    name: this.newLead.lead_user_reference.employee_details.name,
                    _id: this.newLead.lead_user_reference.employee_details._id
                };
            }
            this.newLead.classification = {
                classification: this.classify_classification,
                sales_person: this.classify_sales_person,
                status: this.classify_status
            }
            if (this.newLead.lead_company) {
                this.newLead.lead_company = {
                    name: this.newLead.lead_company.company_details.name,
                    _id: this.newLead.lead_company.company_details._id
                };
            }
            if (this.newLead.referred_by) {
                this.newLead.referred_by = {
                    _id: this.newLead.referred_by._id,
                    name: this.newLead.referred_by.employee_details.name
                };
            }
            if (this.newLead.lead_secondary_attendees.length) {
                this.newLead.lead_secondary_attendees.forEach((x,index) => {
                    this.newLead.lead_secondary_attendees[index] = {
                        _id: x._id,
                        name: x.employee_details.name
                    }
                });
            }
            this.newLead.leads_target.forEach(x => {
                if(x._id) {
                    delete x._id
                }
                x.lead_company = {
                    name: x.lead_company.company_details.name,
                    _id: x.lead_company.company_details._id
                }
                x.lead_user_reference = {
                    name: x.lead_user_reference.employee_details.name,
                    _id: x.lead_user_reference.employee_details._id
                }
                x.branch = {
                    name: x.branch.name,
                    _id: x.branch._id
                }
                x.product = {
                    _id: x.product._id,
                    product_name: x.product.product_name,
                    product_code: x.product.product_code
                }
                x.company_links.forEach(n => {
                    if (!n) {
                        x.company_links = x.company_links.filter(i => i != n);
                    }
                });
                if (!x.to_sales_forecast) {
                    delete x["to_sales_forecast"];
                }
            });
            this.newLead.lead_reminders.forEach(x => {
                if(localStorage.getItem("clone")) {
                    x.event_schedule.start_date = x.event_schedule.start_date
                    if (x.event_schedule.start_date.indexOf("month" !== -1)) {
                        delete x.event_schedule.start_date["month"];
                    }
                    if (x.event_schedule.start_date.indexOf("day" !== -1)) {
                        delete x.event_schedule.start_date["day"];
                    }
                    if (x.event_schedule.start_date.indexOf("ampm" !== -1)) {
                        delete x.event_schedule.start_date["ampm"];
                    }
                }
                else {
                    if ("month" in x.event_schedule.start_date) {
                        delete x.event_schedule.start_date["month"];
                    }
                    if ("day" in x.event_schedule.start_date) {
                        delete x.event_schedule.start_date["day"];
                    }
                    if ("ampm" in x.event_schedule.start_date) {
                        delete x.event_schedule.start_date["ampm"];
                    }
                    x.event_schedule.start_date = x.event_schedule.start_date.toString().split(" ").slice(0,4).toString().split(",").join(" ") + ' ' + x.event_schedule.start_time.toString().split(" ").slice(4).toString().split(",").join(" ")
                    delete x.event_schedule.start_time
                }
            });
            this.newLead.attachments.forEach(x => {
                delete x["created_time"];
                delete x["error"];
                delete x["id"];
                delete x["progress"];
                delete x["uploading"];
            });
            this.newLead.doc_status = type;
            if (this.newLead.lead_status.includes(" ")) {
                let leadStatus = this.newLead.lead_status.split(" ");
                this.newLead.lead_status = leadStatus[0].toLowerCase() + "_" + leadStatus[1].toLowerCase();
            }
            if (this.newLead.lead_source == "Conventional") {
                delete this.newLead["social_media"];
            } else {
                delete this.newLead["location"];
                delete this.newLead["lead_type"];
                delete this.newLead["referred_by"];
                delete this.newLead["meeting_type"];
                delete this.newLead["lead_secondary_attendees"];
            }
            if(this.newLead.created_by) {
                delete this.newLead.created_by
            }
            if(this.newLead.created_company_id) {
                delete this.newLead.created_company_id
            }
            if(this.newLead.created_time) {
                delete this.newLead.created_time
            }
            if(this.newLead.last_modified_time) {
                delete this.newLead.last_modified_time
            }
            this.newLead.attachments.forEach((x,index)=>{
                this.newLead.attachments[index] = {
                    name: x.name,
                    size: +x.size,
                    url: x.url
                }
            });
            let res = await this.$http.post("/leads/save", this.newLead);
            if (res.data.status_id == 1) {
                if (type === "draft") {
                    localStorage.setItem("draft", true);
                    this.success_msg = "Your Lead data has been successfully saved."
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.$router.push("/listleads");
                    }, 2000);
                }
                else {
                    this.success_lead = true;
                    setTimeout(() => {
                        this.$modal.show('success-message');
                    }, 1000);
                }
            }
        },
        async getLeadsData() {
            this.callInProgress = true;
            let res = await this.$http.get("/leads/get?id=" + localStorage.getItem("clone"));
            if (res.data.status_id == 1) {
                this.newLead = res.data.response;
                if (this.newLead.lead_source == "conventional") {
                    this.lead_source = "Conventional"
                    Object.assign(this.newLead, {
                        social_media: [
                            {
                                account_id: "",
                                account_type: "",
                                account_url: "",
                                logo: ""
                            },
                        ]
                    })
                }
                if(this.newLead.lead_source == "social_media") {
                    this.lead_source = "Social Media"
                    Object.assign(this.newLead, {
                        location: "",
                        lead_type: "",
                        referred_by: "",
                        meeting_type: "",
                        lead_secondary_attendees: [],
                    })
                }
                this.$forceUpdate()
                if (this.newLead.lead_user_reference) {
                    this.newLead.lead_user_reference = {
                        employee_details: {
                            name: this.newLead.lead_user_reference.name,
                            _id: this.newLead.lead_user_reference._id
                        }
                    }
                }
                if (this.newLead.lead_company) {
                    this.newLead.lead_company = {
                        company_details: {
                            name: this.newLead.lead_company.name,
                            _id: this.newLead.lead_company._id,
                        }
                    }
                }
                if (this.newLead.campaign_source) {
                    this.newLead.campaign_source = this.newLead.campaign_source
                }
                if (this.newLead.referred_by) {
                    this.newLead.referred_by = {
                        _id: this.newLead.referred_by._id,
                        employee_details: {
                            name: this.newLead.referred_by.name
                        }
                    }
                }
                if (this.newLead.lead_secondary_attendees.length) {
                    this.newLead.lead_secondary_attendees.forEach((x,index) => {
                        this.newLead.lead_secondary_attendees[index] = {
                            _id: x._id,
                            employee_details: {
                                name: x.name
                            }
                        }
                    });
                }
                if (this.newLead.classification) {
                    this.classify_status = this.newLead.classification.status
                    this.classify_classification = this.newLead.classification.classification
                    if(this.newLead.classification.sales_person) {
                        if(Object.keys(this.newLead.classification.sales_person).length) {
                            this.classify_sales_person = this.newLead.classification.sales_person
                        }
                    }
                    if (this.classify_classification == 'Assigned' || this.classify_classification == 'Reassigned') {
                        this.is_classification_selected = true
                    }
                    if(this.classify_status) {
                        this.is_status_selected = true
                    }
                }
                this.locationIntroduced = this.newLead.location.city + "," + this.newLead.location.street + "," + this.newLead.location.state + "," + this.newLead.location.country;
                this.newLead.leads_target.forEach(x => {
                    x.lead_company = {
                        company_details: {
                            name: x.lead_company.name,
                            _id: x.lead_company._id
                        }
                    }
                    x.lead_user_reference = {
                        employee_details: {
                            name: x.lead_user_reference.name,
                            _id: x.lead_user_reference._id
                        }
                    }
                });
                this.callInProgress = false;
            }
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        }
    },
    created() {
        if (localStorage.hasOwnProperty("clone")) {
            this.date_iso = true;
            this.getLeadsData();
        }
        this.getOrganisationSettings();
        for (let i = 0; i < 6; i++) {
            let year = new Date().getFullYear();
            this.years_to_set.push(year + i);
        };
        const dict = {
            custom: {
                leadcontactnumber: {
                    required: () => 'Contact Number is Required',
                    min: () => 'Invalid Phone Number'
                },
            }
        }
        this.$validator.localize('en', dict)
    },
    destroyed() {
        if (localStorage.hasOwnProperty("clone")) {
            localStorage.removeItem("clone");
        }
    }
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 2px;
        padding-bottom: 2px;
        margin-bottom: 10px;
        padding-right: 20px;
        padding-left: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .header-inner {
        background: #00448b;
        color: #fff;
        padding-top: 4px;
        padding-bottom: 4px;
        margin-bottom: 10px;
        padding-right: 20px;
        padding-left: 20px;
        font-weight: 500;
        font-size: 14px;
    }
    .inner-div {
        padding-top: 10px;
        padding-bottom: 40px;
        padding-left: 80px;
        padding-right: 80px;
    }
    .inputFieldSalesTable {
        font-size: 14px !important;
        display: block;
        width: 8rem;
        border: none;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
        text-align: center;
    }
    .reminders {
        box-shadow: 0 0 3px 0 #939393;
        padding: 5px;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        line-height: 20px;
        justify-content: space-between;
    }
    .calendar {
        border-radius: 5px;
        background: #00448b;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 5em;
        width: 5em;
        font-size: 12px;
    }
    .calendar > span {
        color: #fff;
    }
    .fiscalYearDropdown {
        background: #000;
        margin-top: 20px;
        border-radius: 7.5px;
        border: 0.6px solid #676767 !important;
        padding: 10px;
        display: flex;
    }
    .fiscalYearDropdown .el-dropdown .filters {
        margin: 0 !important;
        padding: 0px 5px !important;
        display: flex !important;
        flex-grow: 1 !important;
    }
    .fiscalYearDropdown .el-dropdown .filters span {
        font-size: 14px !important;
        font-weight: 600 !important;
    }
    .routers{
        max-height: 30px;
        min-width: 35px !important;
        border-radius: 10px !important;
        background-color: #bcb8b8;
    }
    .callreports {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .call-report-number {
        border-radius: 20px;
        background: #00448b;
        color: #fff;
        font-size: 12px;
        padding: 2px 8px 2px 8px;
        margin: 4px;
        line-height: 25px;
        display: inline-block;
        width:155px;
    }
    .activeColor{
        background-color: #f2f3f5 !important;
        color: #707070;
    }
    .activeTab{
		width: 0;
		height: 0;
		border-bottom: 40px solid #f2f3f5;
		border-right: 25px solid transparent;
		margin-top: 7px;
		margin-left: -2px;
    }
    .add-vendor{
        color: rgba(103, 103, 103, 0.84);
        position: inherit;
        background: #ffffff;
        width: 100%;
        height: 34px;
        line-height: 32px;
        padding-left: 18px;
        z-index: 9999;
        cursor: pointer;
        top: 84%;
        border: solid 1px #cdd2da;
    }
    .block-callreport {
        border-radius: 11px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        padding: 5px 50px 15px 50px;
        margin-bottom: 22px;
    }
    .unfinishedCircle {
    background: #e8e8e8;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.32);
    font-weight: 500;
    }
    .finishedCircle {
    background: #128807;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 500;
    }
    .selectedCircle {
    background: #ff9a06;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 500;
    }
    .finishedCircleText {
    position: absolute;
    font-size: 14px;
    color: #303031;
    margin-top: 6em;
    font-weight: 600;
    }

    .unfinishedCircleText {
    position: absolute;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.32);
    margin-top: 6em;
    font-weight: 600;
    }
    .unfinishedDash {
        color: #e8e8e8;
        font-size: 20px;
    }
    .finishedDash {
        color: #128807;
        font-size: 20px;
    }
    .input-white{
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/CreateLeads.vue